import { Box, styled, Theme } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';

type Props = {
  centered?: boolean;
  spacing?: keyof Theme['spacingSizes'];
  className?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  flex?: number;
};

const shouldForwardProp = (prop: string) =>
  ![
    'fullWidth',
    'centered',
    'spacing',
    'justify',
    'flex',
    'fullHeight',
  ].includes(prop);

type StyledColumnProps = Pick<
  Props,
  'centered' | 'spacing' | 'fullWidth' | 'justify' | 'flex' | 'fullHeight'
>;

const StyledColumn = styled(Box, {
  shouldForwardProp,
})<StyledColumnProps>(
  ({ theme, centered, spacing, fullWidth, justify, flex, fullHeight }) => ({
    display: 'flex',
    alignItems: centered ? 'center' : undefined,
    gap: spacing ? theme.spacing(theme.spacingSizes[spacing]) : 0,
    flexDirection: 'column',
    width: fullWidth ? '100%' : undefined,
    justifyContent: justify,
    flex: flex ?? undefined,
    height: fullHeight ? '100%' : undefined,
  }),
);

const Column = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, spacing, className, fullWidth, fullHeight, ...props }, ref) => {
    return (
      <StyledColumn
        ref={ref}
        className={className}
        spacing={spacing}
        fullWidth={fullWidth}
        fullHeight={fullHeight}
        {...props}
      >
        {children}
      </StyledColumn>
    );
  },
);

export default Column;
